<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Header con Filtros y Acciones -->
          <WarehouseListTableHeader
            :title="$t('key_warehouseList_table_title')"
            :description="$t('key_warehouseList_table_description')"
            :enable-reload="true"
            :enable-search="true"
            :selected-ids="selectedIds"
            :list-filters="filters"
            @search-change="searchChange"
            @reload-page="reloadPage">  <!-- TODO: Pendiente de calibrar los componentes por las preferencias del usuario --> 
          </WarehouseListTableHeader>
          
          <!-- Tabla con los Datos -->
          <GenericTableV2
            ref="genericTable"
            :items="warehousesData?.items"
            :pagination="pagination"
            :headers="headers"
            :selected-ids="selectedIds"
            :is-loading="isLoading"
            @changed-header="onChangeHeader"
            @changed-page="paginationPageChange"
            @changed-row="paginationRowChange"
            @changed-selection="changedSelection">
            <template #row="{item}">
              <td style="width: 40%" class="text-xs cursor-pointer font-weight-bold mb-0 picko-link">
                <div class="d-flex">
                  <div class="my-auto form-check">
                    <input :id="item._id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item._id)" @change="changedSelection(item._id)" >
                  </div>
                  <h6 class="my-auto ms-3 picko">
                    <a class="font-weight-bold text-primary" href="#" @click.prevent="openWarehouse(item.name)">
                      {{ item.name }}
                    </a>
                  </h6>
                </div>
              </td>
              <td class="font-weight-bold text-success">
                <span class="my-2 text-xs">{{$numberFormat.toDecimalFormat(item.available)}}</span>
              </td>
              <td class="font-weight-bold text-warning">
                <span class="my-2 text-xs">{{$numberFormat.toDecimalFormat(item.booked)}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{$dateUtils.toDDMMYYYYHH(item.updated_at)}}</span>
              </td>
            </template>
          </GenericTableV2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  // IMPORTS
  import { mapState, mapActions } from "vuex";
  import GenericTableV2 from "./../../../../generic_components/GenericTableV2.vue";
  import WarehouseListTableHeader from "./../components/WarehouseListTableHeader.vue";

  export default {
    name: "WarehouseList",
    components: {
      GenericTableV2,
      WarehouseListTableHeader,
    },
    data() {
      return{
        myAccount: JSON.parse(localStorage.getItem("user")),
        filters: {
          search: '',
          status: '',
          sort: {
            sort: '',
            order: ''
          }
        },
        isLoading: false,
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50, 100, 200]
        },
        selectedIds: []
      }
    },
    computed: {
      ...mapState('warehouse', {
        warehousesData: state => state.list.data,
        warehousesResponse: state => state.list.response,
        warehousesStatus: state => state.list.status
      }),
      listFilters() {
        return this.$store.state.warehouse.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_WarehouseList_name'), sort: { sorteable: true, order: '' }, column: 'name' },
          { title: this.$t('key_theader_WarehouseList_available'), sort: { sorteable: true, order: '' }, column: 'available' },
          { title: this.$t('key_theader_WarehouseList_booked'), sort: { sorteable: true, order: '' }, column: 'booked' },
          { title: this.$t('key_theader_WarehouseList_updated_at'), sort: { sorteable: false, order: '' }, column: 'updated_at' }
        ]
      }
    },
    watch: {
      warehousesResponse() {
        if(this.warehousesData) {
          this.pagination.total = this.warehousesData.total;
          this.isLoading = false;
        }
      }
    },
    mounted() {
      this.setUpFilters();
      if (Object.keys(this.$route.query).length > 0) {
        this.filters.status = this.$route.query.status;
      }
      this.getWarehousesList();
    },
    methods: {
      ...mapActions('warehouse', [
                             'getWarehouses',
                             'getWarehouseStock'
                            ]),
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }
        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      async getWarehousesList() {
        if (this.warehousesStatus === 'loading' || this.isLoading) {
          return;
        }
        
        this.isLoading = true;
        try {
          if (this.$PickoVersion.isV2()) {
            await this.getWarehouseStock({filters: this.filters, pagination: this.pagination});
          } else {
            await this.getWarehouses({filters: this.filters, pagination: this.pagination});
          }

          if (this.warehousesStatus === 'success' && this.warehousesResponse.status === 200 && this.myAccount.notifications) {
            this.$notify({
              title: this.$t('key_header_successful_retrieving_data'),
              message: this.$t('key_message_successful_retrieving_data'),
              icon: { component: 'fa-solid fa-check', color: 'white' },
              color: 'success',
              show: true,
              duration: 5000
            });
          } else if(this.warehousesStatus !== 'success') {
            this.$notify({
              title: this.$t('key_header_error_retrieving_data'),
              message: this.$t('key_message_error_retrieving_data'),
              icon: { component: 'fa-solid fa-xmark', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t('key_header_error_unexpected'),
            message: this.$t('key_message_error_unexpected'),
            icon: { component: 'fa-solid fa-xmark', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000
          });
        } finally {
          this.isLoading = false;
        }
      },
      changedSelection(id) {
        if (this.selectedIds.includes(id)) {
          this.selectedIds = this.selectedIds.filter(itemId => itemId !== id);
        } else {
          this.selectedIds.push(id);
        }
      },
      clearSelection() {
        this.selectedIds = [];
      },
      async searchChange(value) {
        this.pagination.currentPage = 1;
        this.filters.search = value;
        await this.getWarehousesList();
      },
      async reloadPage() {
        await this.getWarehousesList();
      },
      async onChangeHeader(val){
        this.filters.sort = {
          sort: val.column,
          order: val.order=="asc"?"ascending":"descending"
        }
        await this.getWarehousesList(); 
      },
      async paginationPageChange(page) {
        this.pagination.currentPage = page;
        await this.getWarehousesList(); 
      },
      async paginationRowChange(rows) {
        this.pagination.rows = rows;
        await this.getWarehousesList(); 
      },
      openWarehouse(name) {
        this.$router.push({ path: "/Reports/ProductStock", state: { warehouse: name }});
      }
    }
  };

</script>
